module.exports = __webpack_public_path__ + "static/media/blogbackground.4959afff.webp";